import { Component, OnInit } from '@angular/core';
import { AppMainComponent } from 'src/app/app.main.component';
import { LeadModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { AppMainService } from '../../../app-main.service';
import { ObjectNames } from '../../../shared/constants';
import { ConfigurationService } from '../../configurationService';
import { MenuItems, ObjectNames as ChannelObjectNames } from '../constants/constants';
import { CrmLeadsService } from './leads.service';

@Component({
    selector: 'app-crm-leads',
    templateUrl: './leads.component.html',
    styleUrls: ['./leads.component.scss']
})
export class CrmLeadsComponent implements OnInit {
    allLeadsStages = [];
    moduleId = LeadModuleId;

    leadsTemplatesConfig;
    allLeadsTemplates = [];
    availableLeadsLabelsContact = [];

    // Fields
    leadsSources = [];
    leadsStatus = [];
    leadsTypes = [];

    emailConfigLead;
    leadsEmail = [];

    phoneConfigLead;
    leadsPhone = [];

    socialConfigLead;
    leadsSocial = [];

    caseChannelConfig;
    allCaseChannels = [];

    caseTemplatesConfig;
    allInventoryStages = [];
    allCaseTemplates = [];

    configMenuCaseItems = [];
    index = 0;
    caseChannelId;
    templateTypeId;
    pipelineTypeId = null;

    sectionTypeId
    addNewElement;
    addNewField;

    //fields
    leadFieldConfig = null
    // allAccountfieldJSON = [];

    constructor(
        private service: ConfigurationService,
        private appMainService: AppMainService,
        public app: AppMainComponent,
        private crmLeadsService: CrmLeadsService
    ) { }

    ngOnInit(): void {

        // this.getConfigurationTypes();
        this.getLeadChannels();
        this.configMenuCaseItems = [
            // {
            //     label: MenuItems.Channel,
            //     icon: 'pi pi-plus',
            //     command: () => {
            //         this.addNewCaseChannel();
            //     }
            // },
            {
                label: MenuItems.FieldData,
                icon: 'pi pi-plus',
                command: () => {
                    this.addNewCaseFieldData();
                }
            },
        ];
    }

    getLeadChannels(){
        this.crmLeadsService.getChannelByModuleId(this.moduleId).subscribe(channels=>{
            this.allCaseChannels = channels;
        })
    }

    getConfigurationTypes() {
        this.appMainService.isShowSpinner('loadTypes')
        this.crmLeadsService.getAllTypes().subscribe(
            types => {
                this.appMainService.isHideSpinner('loadTypes')
                this.caseChannelId = types.find(type => type.name == ChannelObjectNames.leadConstants.Channel_Object).id;
                this.templateTypeId = types.find(type => type.name == ChannelObjectNames.leadConstants.Channel_Template).id;
                this.pipelineTypeId = types.find(type => type.name == ChannelObjectNames.leadConstants.Pipeline_Object).id;
                this.loadConfigurations();
            },
            () => {
                this.appMainService.isHideSpinner('loadTypes')
            })
    }

    getIndex(event) {
        this.index = event.index;
        this.addNewField ='';
    }

    reLoadConfigurations(event) {
        this.loadConfigurations();
    }

    loadConfigurations() {
        this.appMainService.isShowSpinner('loadConfiguration')
        this.service.getCaseConfigurations('lead').subscribe(
            configs => {
                this.appMainService.isHideSpinner('loadConfiguration')
                //Case channel
                this.caseChannelConfig = configs.find(s => s.name == ObjectNames.LEAD_CHANNEL && s.typeId == this.caseChannelId);
                const allCaseChannelsJSON = (this.caseChannelConfig && this.caseChannelConfig.configurationDetails && this.caseChannelConfig.configurationDetails[0].configJSONValue != "" ? JSON.parse(this.caseChannelConfig.configurationDetails[0].configJSONValue) : []);
                this.allCaseChannels = allCaseChannelsJSON ? allCaseChannelsJSON.filter(obj => obj.id > 0) : [];
                ////console.log('this.allLeadChannels', this.allCaseChannels);

                //Case Template
                this.caseTemplatesConfig = configs.find(s => s.name == ObjectNames.LEAD_TEMPLATE && s.typeId == this.templateTypeId);
                const allcaseTypeTemplateJSON = (this.caseTemplatesConfig && this.caseTemplatesConfig.configurationDetails && this.caseTemplatesConfig.configurationDetails[0].configJSONValue != "" ? JSON.parse(this.caseTemplatesConfig.configurationDetails[0].configJSONValue) : []);
                this.allCaseTemplates = allcaseTypeTemplateJSON ? allcaseTypeTemplateJSON.filter(obj => obj.id > 0) : [];
                ////console.log('this.allLeadTemplates', this.allCaseTemplates);

                //fields data
                this.leadFieldConfig = configs.filter(s => s.name == ObjectNames.LEAD_EMAIL_TYPES || s.name == ObjectNames.LEAD_PHONE_TYPES || s.name == ObjectNames.LEAD_SOCIAL_TYPES);
            },
            err => {
                this.appMainService.isHideSpinner('loadConfiguration')
            }
        );
    }

    addNewCaseChannel() {
        this.addNewElement = { name: MenuItems.Add_Event_Channel };
        this.index = 0;
    }

    addNewCaseFieldData() {
        this.index = 2;
        this.addNewField = { name: MenuItems.Add_Event_Field };
    }

}
